import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';
import {Component, OnInit, ViewChild} from '@angular/core';
import {DataService} from '@cosbeni/database';
import {KobeacService} from './kobeac.service';
import {KobeacItemGridBase} from './item-grid.base';

/** kobe-ac 売買履歴 (旧 /auction/history) */
@Component({
    standalone: false,
    selector: 'kobeac-history',
    templateUrl: 'history.component.html',
})
export class KobeacHistoryComponent extends KobeacItemGridBase implements OnInit {
    @ViewChild('itemGrid') itemGrid: wjcGrid.FlexGrid;
    bidder: any = null;
    bidders: any[] = [];

    constructor(dataService: DataService, kobeac: KobeacService) {
        super(dataService, kobeac);
    }

    async ngOnInit() {
        await this.kobeac.ensureLoaded();
        this.initMaps();
        this.bidders = this.kobeac.customers
            .filter((c) => c['買主'] && !(c['無効'] === true))
            .map((c) => ({id: c, text: c.ID + ' ' + c['名称']}));
        this.items.filterOnServer = true;
    }

    biddersSource = (query: string, max: number, callback: Function) => {
        const q = (query || '').toLowerCase();
        const results = this.bidders.filter((b) => b.text.toLowerCase().indexOf(q) >= 0);
        if (results.length > 0) callback(results);
    };

    onBidderChanged(): void {
        if (wjcCore.isObject(this.bidder)) {
            this.items.filterSpecial = '`買主` = ' + this.bidder['@rid'];
            this.items.filterOnServer = true;
        }
    }
}
